<template>
  <div
    @click="showComingSoon"
    class="h-full rounded-3xl p-6 overflow-hidden cursor-pointer hover:shadow-lg transition-all duration-300 flex flex-col items-center justify-center"
    style="background-color: #69CBD8;"
  >
    <!-- Coming Soon Content -->
    <div class="text-center">
      <svg class="w-10 h-10 mx-auto mt-6 mb-2 text-white opacity-80" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
      </svg>
      <h2 class="text-3xl font-bold text-white">Planned Trips</h2>
      <p class="text-white text-lg font-medium p-4 mb-6">Coming Soon!</p>
    </div>

    <!-- Coming Soon Modal -->
    <ComingSoonModal :isVisible="showComingSoonModal" @close="showComingSoonModal = false"/>
  </div>
</template>

<script>
import ComingSoonModal from '@/components/ComingSoonModal.vue';

export default {
  name: 'PlannedTripsComponent',
  components: {
    ComingSoonModal
  },
  data() {
    return {
      showComingSoonModal: false
    };
  },
  methods: {
    showComingSoon() {
      this.showComingSoonModal = true;
    }
  }
}
</script>

<style scoped>
/* Smooth transitions */
.transition-all {
  transition: all 0.3s ease;
}
</style>
